import React, { useMemo } from "react";
import ChartContainer from "../chart-container";
import lang from "translations";
import { Path } from "paths";
import styles from "./top-spending-guests-chart.module.scss";

const TopSpendingGuestsChart = ({ ...props }) => {
  const data = useMemo(() => {
    return props.mappedData.map((p, index) => {
      const total = `${p.total || ""}`.trim();
      const [currency = "", ...amountParts] = total.split(" ");

      return {
        id: `${p.name}-${index}`,
        rank: index + 1,
        name: p.name,
        currency,
        amount: amountParts.join(" ") || total,
      };
    });
  }, [props.mappedData]);
  const isEmpty = !props.mappedData.length;

  return (
    <ChartContainer
      title={{
        to: Path.GUEST,
        name: lang.topSpendingGuests,
      }}
      {...props}
      empty={false}
      paddingless
      className={styles.card}
    >
      {isEmpty ? (
        <div className={styles.emptyState}>{lang.noDataAvailable}</div>
      ) : (
        <div className={styles.table}>
        <div className={styles.headerRow}>
          <span className="text-xs">{lang.guest}</span>
          <span className="text-xs">{lang.spend}</span>
        </div>

        {data.map((guest) => (
          <div className={styles.row} key={guest.id}>
            <span className={styles.left}>
              <span className={styles.rank}>{guest.rank}</span>
              <span className={styles.name}>{guest.name}</span>
            </span>
            <span className={styles.total}>
              {guest.currency ? <span className={styles.currency}>{guest.currency}</span> : null}
              <span className="font-semibold text-base text-[var(--teal)]">{guest.amount}</span>
            </span>
          </div>
        ))}
        </div>
      )}
    </ChartContainer>
  );
};

export default TopSpendingGuestsChart;
